import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { useInvalidateChannelsList } from '@/entities/channel';
import type { TelegramAuthResult } from '@/shared/api/channels/telegramPersonal';
import { useNotifications } from '@/shared/ui/Notifications';

export function useTelegramAuthAction<T>(
  request: (data: T) => Promise<TelegramAuthResult>
) {
  const { t } = useTranslation();
  const { addNotification } = useNotifications();
  const invalidateChannelsList = useInvalidateChannelsList();
  return useMutation({
    mutationFn: request,
    onSuccess: () => {
      void invalidateChannelsList();
    },
    onError: (error) => {
      addNotification({
        title: error.message || t('common:errors.genericTitle'),
        caption: error?.data?.details || t('common:errors.generic'),
      });
    },
  });
}
